module.exports = __webpack_public_path__ + "img/火龙果6.3a262f42.png";